module.exports = __webpack_public_path__ + "img/3.594f1f73.png";